import { Navigate, useParams } from "react-router-dom";
import { RESERVED_SLUGS } from "@/config/reservedSlugs";
import BlogArticlePage from "@/pages/blog/BlogArticlePage";

/** Root /:slug — blog article unless reserved or empty. */
export default function BlogRootSlugGate() {
  const { slug } = useParams();
  const s = (slug || "").toLowerCase();
  if (!s || RESERVED_SLUGS.has(s)) {
    return <Navigate to="/" replace />;
  }
  return <BlogArticlePage />;
}
